import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "panel" }
const _hoisted_3 = { class: "panel-heading is-flex" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "Recent Registrations", -1)
const _hoisted_5 = {
  class: "buttons",
  style: {"margin-left":"auto"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus-circle" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Create Registration", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Complete Draft Registration", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fas fa-search" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "pl-2" }, "Registration Search", -1)
const _hoisted_12 = { class: "panel-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_readOnlyGrid = _resolveComponent("readOnlyGrid")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          (_ctx.userAuth.canCreateRegistration)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                class: "button is-info",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: _ctx.routeNames.registrationCreate })))
              }, [
                _hoisted_6,
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_ctx.userAuth.canCreateRegistration)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                type: "button",
                class: "button is-info",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showDraftsDialog')))
              }, [
                _hoisted_8,
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          _createVNode("button", {
            type: "button",
            class: "button is-info",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: _ctx.routeNames.search })))
          }, [
            _hoisted_10,
            _hoisted_11
          ])
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", null, [
          _createVNode(_component_readOnlyGrid, {
            gridColumns: _ctx.gridColumns,
            gridItems: _ctx.gridItems,
            isLoading: _ctx.isLoading,
            "page-items-options": [5, 10, 20],
            excelExportOptions: _ctx.excelExportSettings
          }, null, 8, ["gridColumns", "gridItems", "isLoading", "excelExportOptions"])
        ])
      ])
    ])
  ]))
}